/**
 * Where the API client gets its auth headers. The AuthProvider registers a provider for the
 * active mode (bearer token for Supabase; X-Org-Id and X-User for the dev bypass).
 */
export type AuthHeaders = Record<string, string>;
type Provider = () => AuthHeaders | Promise<AuthHeaders>;

let provider: Provider = () => ({});

export function setAuthHeadersProvider(p: Provider): void {
  provider = p;
}

export async function authHeaders(): Promise<AuthHeaders> {
  return provider();
}
